import React, { useState } from "react";
import { FormControl, Button, Alert } from "react-bootstrap";
import { PostData } from "../APIs/api-routes.util";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/logo.png";
import { isMobile } from "react-device-detect";

function Login() {
  const [errorMessage, setErrorMessage] = useState("");
  const [show, setShow] = useState(false);

  const [data, setData] = useState({
    password: "",
  });
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    PostData(data).subscribe((res: any) => {
      if ("response" in res && res.response?.status === "200") {
        const response = res.response;
        localStorage.setItem("user_info", JSON.stringify(response));
        navigate("/dashboard");
      } else {
        setErrorMessage("Please enter correct password");
        setShow(true);
      }
    });
  };

  return (
    <div style={{height:'100vh'}} className="main-container">
      <div className="main-heading" style={isMobile ? {height:'20vh'} : {padding:'0px'}}>
        <img width={'200px'}  style={isMobile ? {padding:'20px'} : {padding:'0px'}} src={logo} alt="" />
        <h1>Appointment Booking Admin</h1>
      </div>
      <div style={isMobile ? {height:'80vh'} : {padding:'0px'}}  className="login-container">
        <form style={isMobile ? {width:'90%' ,height:'60%'} : {width:'500px', height:'80%'} } className="login-content" onSubmit={handleSubmit}>
          <FormControl
            id="formControlsText"
            type="text"
            placeholder="Enter Name"
            value={"Muhammad Umar Farooq"}
          />

          <FormControl
            id="formControlsPassword"
            placeholder="Password"
            type="password"
            onChange={(e) => {
              setData({ password: e.target.value });
            }}
          />
          <div style={{width:'100%'} } className="submit-button">
            <Button style={isMobile ? {width:'120px'} :{ width: "200px" }} type="submit">
              Submit
            </Button>
          </div>
        </form>
      </div>
      <div className="alert-div" style={isMobile ? { width: "95%" }:{ width: "600px" }} >
        <Alert
          show={show}
          onClose={() => setShow(false)}
          dismissible
          variant="danger"
        >
          {errorMessage}
        </Alert>
      </div>
    </div>
  );
}

export default Login;
